import { Injectable } from '@angular/core';

@Injectable()
export abstract class ExgMapAPILoader {
  abstract load(): Promise<void>;
}
